// import { arduinoGenerator } from './generator';
import { ArduinoGenerator } from './arduinoGenerator';
import * as procedures from './procedureBlocks';
import * as variables from './variableBlocks';
import * as control from './controlBlocks';
import * as logic from './logicBlocks';
import * as variablesValue from './variablesValueBlocks';
import * as morse from './morseBlocks';
import * as text from './textBlocks';
import * as math from './mathBlocks';
import * as outputs from './outputsBlocks';
import * as camera from './cameraBlocks';
import * as controlJunior from './controlJuniorBlocks';
import * as motors from './motorsBlocks';
import * as inputDigital from './inputDigital';
import * as inputAnalog from './inputAnalog';
import * as arduinoUno from './arduinoUnoBlocks';
import * as serial from './serialBlocks';
import * as bluetooth from './bluetoothBlocks';
import * as lcd from './lcdBlocks';
import * as matrix from './matrixBlocks';
import * as bhoot from './bhootBlocks';
import * as eduplug from './eduplugBlocks';
import * as lgo from './lgoBlocks';
import * as iaco from './iacoBlocks';
import * as copaRobotica from './copaRoboticaBlocks';
import * as ciudad from './ciudadBlocks';
import * as ciudadFlor from './ciudadFlorBlocks';
import * as ciudadLuces from './ciudadLucesBlocks';
import * as ciudadPlanetario from './ciudadPlanetarioBlocks';
import * as ciudadSemaforos from './ciudadSemaforosBlocks';
import * as ciudadTren from './ciudadTrenBlocks';
import * as createc from './createcBlocks';
import * as createcFloralis from './createcFloralisBlocks';
import * as createcMadero from './createcMaderoBlocks';
import * as createcObelisco from './createcObeliscoBlocks';
import * as createcPlanetario from './createcPlanetarioBlocks';
import * as createcRetiro from './createcRetiroBlocks';
import * as ai from './aiBlocks';

const arduinoGenerator = new ArduinoGenerator();

const generators = {
  // SENIOR BLOCKS
  ...procedures,
  ...variables,
  ...control,
  ...logic,
  ...variablesValue,
  ...morse,
  ...text,
  ...math,
  ...outputs,
  ...camera,
  ...motors,
  ...inputDigital,
  ...inputAnalog,
  ...arduinoUno,
  ...serial,
  ...bluetooth,
  ...lcd,
  ...matrix,
  ...bhoot,
  ...eduplug,
  ...lgo,
  ...iaco,
  ...copaRobotica,
  ...ciudad,
  ...ciudadFlor,
  ...ciudadLuces,
  ...ciudadPlanetario,
  ...ciudadSemaforos,
  ...ciudadTren,
  ...createc,
  ...createcFloralis,
  ...createcMadero,
  ...createcObelisco,
  ...createcPlanetario,
  ...createcRetiro,
  ...ai,
  // JUNIOR BLOCKS
  ...controlJunior,
};

Object.keys(generators).forEach(name => {
  arduinoGenerator.forBlock[name] = generators[name];
});

export default arduinoGenerator;